import { render, staticRenderFns } from "./CanvasSegmentationPointMode.vue?vue&type=template&id=41eb0640&scoped=true&"
import script from "./CanvasSegmentationPointMode.vue?vue&type=script&lang=ts&"
export * from "./CanvasSegmentationPointMode.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasSegmentationPointMode.vue?vue&type=style&index=0&id=41eb0640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eb0640",
  null
  
)

export default component.exports